import React, { useState } from 'react';
import './Navbar.css';
import { Link, useLocation } from 'react-router-dom';
import { useAuth } from '../../Context/Authcontext';

function Navbar() {
  const { isloggedin, bardis, userdata } = useAuth();
  const [navOpen, setNavOpen] = useState(false);
  const location = useLocation();

  const toggleNav = () => setNavOpen(!navOpen);
  const closeNav = () => setNavOpen(false);

  return (
    <>
      {/* Overlay */}
      {navOpen && <div className="overlay-menu" onClick={closeNav}></div>}

      {location.pathname === '/' && (
        <Link to="/product" className="nav-link w-100 d-flex align-items-center justify-content-center py-2" style={{backgroundColor: '#5C3A1E'}}>
          <p className="mb-0 text-white body-font-bold text-center letter-spacing promo-strip-text">UPTO 40% OFF ON ALL PRODUCTS &nbsp;—&nbsp; SHOP NOW</p>
        </Link>
      )}

      {
        window.innerWidth < 800 && (
          <div className="w-100 d-flex align-items-center justify-content-center bg-brand-secondary py-1">
            <img src="/assets/money.png" alt="cash on delivery" width={25} className='me-2' />
            <p className="mb-0 lh-sm text-white fs-sm">Cash On Delivery Available!</p>
          </div>
        )
      }

      <nav className="navbar navbar-expand-lg bg-white border-bottom py-3">
        <div className="container-fluid d-flex justify-content-between align-items-center px-4">

          <Link to={'/'} style={{ maxWidth: "min(200px, 50%)" }} ><img src="/assets/penta-logo.png" alt="logo" className='me-4 w-100' /></Link>

          {/* Desktop Links */}
          <div className="d-none d-lg-flex align-items-center gap-4">
            <Link className="text-dark body-font-light text-decoration-none" to="/">Home</Link>
            <Link className="text-dark body-font-light text-decoration-none" to="/product">Products</Link>
            <Link className="text-dark body-font-light text-decoration-none" to="/about">About</Link>
            {/* <Link className="text-dark body-font-light text-decoration-none" to="#">Blog</Link> */}
            <Link className="text-dark body-font-light text-decoration-none" to="/orders">Orders</Link>
            <Link className="text-dark body-font-light text-decoration-none" to="/contact">Contact</Link>
          </div>

          {/* Search and Icons */}
          <div className="d-flex align-items-center">
            <form className="d-none d-lg-flex align-items-center border rounded px-3 py-1 me-5" style={{ maxWidth: '280px' }}>
              <img src="/assets/money.png" alt="cash on delivery" width={30} className='me-2' />
              <p className="mb-0 lh-sm fs-sm">Cash On Delivery Available!</p>
            </form>
            <div className="d-flex align-items-center gap-3 ms-3">
              {/* Mobile Hamburger Icon */}
              <Link to={'/cart'} className="nav-link" style={{position: 'relative'}}>
                <i className="fas fa-shopping-bag text-dark"></i>
                {
                  userdata && userdata?.cart?.length > 0 && (
                    <p className="mb-0 fs-esm d-flex align-items-center justify-content-center" 
                      style={{
                        position: 'absolute', 
                        width: '15px',
                        height: '15px',
                        borderRadius: '50%',
                        backgroundColor: 'red',
                        color: 'white',
                        right: '-10px',
                        top: '0px'
                      }}
                    >{userdata?.cart?.reduce((total, item) => total + item.quantity, 0)}</p>
                  )
                }
              </Link>
              {
                isloggedin && (
                  <Link to={'/profile'} className="nav-link">
                    <i className="fas fa-user text-dark"></i>
                  </Link>
                )
              }
              <div className="d-lg-none cursor-pointer" onClick={toggleNav}>
                <i className="fas fa-bars fs-4 text-dark"></i>
              </div>
            </div>
          </div>
        </div>
      </nav>

      {/* Slide-out Mobile Menu */}
      <div className={`mobile-menu ${navOpen ? 'open' : ''}`}>
        <div className="d-flex flex-column justify-content-between p-4 pt-3 h-100">
          <div className="d-flex flex-column gap-3">
            <Link to={'/'}><img src="/assets/penta-logo.png" width={170} alt="logo" className='mb-3' /></Link>
            <Link onClick={closeNav} className="text-dark text-decoration-none" to="/">Home</Link>
            <Link onClick={closeNav} className="text-dark text-decoration-none" to="/product">Products</Link>
            <Link onClick={closeNav} className="text-dark text-decoration-none" to="/about">About</Link>
            {/* <Link onClick={closeNav} className="text-dark text-decoration-none" to="#">Blog</Link> */}
            <Link onClick={closeNav} className="text-dark text-decoration-none" to="/orders">Orders</Link>
            <Link onClick={closeNav} className="text-dark text-decoration-none" to="/contact">Contact Us</Link>
          </div>
          <div>
            <p className="mb-0 fs-esm"><span className="body-font-bold">Phone:</span> <Link to="tel:+917738494171" className="nav-link d-inline">+917738494171</Link></p>
            <p className="mb-0 fs-esm"><span className="body-font-bold">Address:</span> Sai Plush Apartment, Kon, Kalyan, Kongaon, Maharashtra 421311</p>
            <div className="mt-3">
              <Link to="https://instagram.com/" className="text-dark me-3"><i className="fab fa-facebook-f"></i></Link>
              <Link to="https://instagram.com/" className="text-dark me-3"><i className="fab fa-instagram"></i></Link>
              <Link to="https://instagram.com/" className="text-dark me-3"><i className="fab fa-twitter"></i></Link>
              <Link to="https://instagram.com/" className="text-dark me-3"><i className="fab fa-youtube"></i></Link>
              <Link to="https://instagram.com/" className="text-dark"><i className="fab fa-pinterest-p"></i></Link>
            </div>
            <div className="border-top pt-3 d-flex flex-column flex-md-row justify-content-between mt-3">
              <p className="mb-2 mb-md-0 fs-esm">&copy; 2025 Pentadeco. All Rights Reserved.</p>
              <div className="d-flex flex-wrap align-items-center">
                <span className="me-2">Payment:</span>
                <div className="payment-icons d-flex align-items-center">
                  <img src="https://img.icons8.com/color/30/visa.png" alt="Visa" />
                  <img src="https://img.icons8.com/color/30/mastercard.png" alt="MasterCard" />
                  <img src="https://img.icons8.com/color/30/amex.png" alt="Amex" />
                  <img src="https://img.icons8.com/color/30/paypal.png" alt="PayPal" />
                  <img src="https://img.icons8.com/color/30/discover.png" alt="Discover" />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default Navbar;
